module.exports = __webpack_public_path__ + "static/troubleshooting-958d2d31f2c53451f241c54d94d7f222.svg";